import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class Header extends Component {
  render() {
    return (
      <header className={'App__header-' + this.props.headerType}>
        <div className="announcement-bar"></div>
        <div className="site-header-sections page-width">
          <div className="site-header-section site-header-side"></div>
          <div className="site-header-section site-logo">
            <Link to="/"><img src="/images/hello-made-horizontal-white_x20.png" alt=""></img></Link>
          </div>
          <div className="site-header-section site-header-side">
              <div className="App__view-cart-wrapper">
                <a className="App__view-cart" onClick={this.props.onClick}>
                  <svg className="shopping-bag-icon" viewBox="0 0 27.2 27" focusable="false" role="presentation" aria-hidden="true">
                  <path d="M19.6 9c-.2-5.1-2.7-9-6-9s-5.8 3.9-6 9h-4v18h20V9h-4zm-6-7c2.1 0 3.8 3.2 4 7h-8c.2-3.8 1.9-7 4-7zm-8 23V11h11v14h-11zm16 0h-3V11h3v14z"></path>
                  </svg>
                </a>
              </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js